var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectfieldRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C7.71875 17 7.46875 16.9062 7.28125 16.7188C6.875 16.3438 6.875 15.6875 7.28125 15.3125L12.5625 10L7.28125 4.71875C6.875 4.34375 6.875 3.6875 7.28125 3.3125C7.65625 2.90625 8.3125 2.90625 8.6875 3.3125L14.6875 9.3125C15.0938 9.6875 15.0938 10.3438 14.6875 10.7188L8.6875 16.7188C8.5 16.9062 8.25 17 8 17Z",
    fill: "url(#paint0_linear_3403_3994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3403_3994",
    x1: 1.5,
    y1: 2,
    x2: 17,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#0D0C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectfieldRight);
export default __webpack_public_path__ + "static/media/icon-selectfield-right.808ba27c810eda9c6e37cb05c80f08b8.svg";
export { ForwardRef as ReactComponent };